import { Box, IconButton } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useState } from 'react';
import { DiagnosticoLeftPanel, SecondaryTab } from './DiagnosticoLeftPanel';
import { DiagnosticoRightPanel, DiagnosticoRightPanelProps } from './DiagnosticoRightPanel';
import './diagnosticoV2.scss';

type SplitMode = 'expand_left' | 'balanced' | 'expand_right';

export interface DiagnosticoSplitViewProps extends DiagnosticoRightPanelProps {
    mode?: 'liquidLevel' | 'dynCard' | 'generic';
    liquidLevel?: any;
    originFieldActivityId?: string;
    variablesToUpdate?: any;
    onChangeLiquidLevel?: (value: number, label: string) => void;
    secondaryTab?: SecondaryTab;
    onSecondaryTabChange?: (tab: SecondaryTab) => void;
}

export const DiagnosticoSplitView = (props: DiagnosticoSplitViewProps) => {
    const { mode, liquidLevel, variablesToUpdate, onChangeLiquidLevel, secondaryTab: externalSecondaryTab, onSecondaryTabChange, originFieldActivityId } = props;
    const [splitMode, setSplitMode] = useState<SplitMode>('balanced');
    const defaultSecondary: SecondaryTab = mode === 'liquidLevel' ? 'actualizarNivel' : 'ipr';
    const [internalSecondaryTab, setInternalSecondaryTab] = useState<SecondaryTab>(defaultSecondary);
    const secondaryTab = externalSecondaryTab ?? internalSecondaryTab;
    const setSecondaryTab = onSecondaryTabChange ?? setInternalSecondaryTab;

    const cycleSplitMode = () => {
        setSplitMode((prev) => {
            if (prev === 'expand_left') return 'balanced';
            if (prev === 'balanced') return 'expand_right';
            return 'expand_left';
        });
    };

    return (
        <Box className={`diagnostico_v2_split_view ${splitMode}`} sx={{ flex: 1, width: '100%', height: '100%', minHeight: 420 }}>
            <Box className="split_panel">
                <DiagnosticoLeftPanel
                    activeTab={secondaryTab}
                    onTabChange={setSecondaryTab}
                    mode={mode}
                    liquidLevel={liquidLevel}
                    variablesToUpdate={variablesToUpdate}
                    onChangeLiquidLevel={onChangeLiquidLevel}
                    isCompact={splitMode === 'balanced'}
                />
            </Box>
            <Box className="split_divider" onClick={cycleSplitMode}>
                <IconButton size="small" aria-label="Alternar paneles: solo izquierda / ambos / solo derecha">
                    {splitMode === 'expand_left' ? (
                        <Box component="span" sx={{ display: 'flex', alignItems: 'center' }}>
                            <ChevronLeftIcon fontSize="small" sx={{ mr: -0.5 }} />
                            <ChevronRightIcon fontSize="small" />
                        </Box>
                    ) : splitMode === 'balanced' ? (
                        <ChevronLeftIcon fontSize="small" />
                    ) : (
                        <ChevronRightIcon fontSize="small" />
                    )}
                </IconButton>
            </Box>
            <Box className="split_panel">
                <DiagnosticoRightPanel
                    activeDiagnostic={props.activeDiagnostic}
                    onDiagnosticChange={props.onDiagnosticChange}
                    condicionFondoList={props.condicionFondoList}
                    lastProductionTest={props.lastProductionTest}
                    lastWaterTest={props.lastWaterTest}
                    averageWaterTestsLast5={props.averageWaterTestsLast5}
                    originFieldActivityId={originFieldActivityId ?? liquidLevel?.fieldActivityId}
                    isCompact={splitMode === 'balanced'}
                    addRemoveOptimizationActivity={props.addRemoveOptimizationActivity}
                    handleConvertToMain={props.handleConvertToMain}
                    onOpenQuickAddRequirement={props.onOpenQuickAddRequirement}
                    onOpenQuickAddOptimization={props.onOpenQuickAddOptimization}
                    onGenerateDiagnostic={props.onGenerateDiagnostic}
                />
            </Box>
        </Box>
    );
};
